import React, { FC } from 'react';
import styles from '../TableOptions.module.scss';
import { Tooltip } from 'antd';
import ColumnSelection from '../../../../assets/images/columnVisibility.svg';

type Props = {
  setShowModalTable: (hide: boolean) => void;
};

const ColumnSelector: FC<Props> = ({ setShowModalTable }) => {
  return (
    <>
      <Tooltip title='Column Selection'>
        <img src={ColumnSelection} alt='Column Selection' className={styles.columnVisibilityIcon} onClick={() => setShowModalTable(true)} />
      </Tooltip>
    </>
  );
};

export default ColumnSelector;
